/**
 * A collection of useful higher-order TypeScript types.
 */

/**
 * A type that's like Partial, but certain properties are still required.
 */
export type AtLeast<T, K extends keyof T> = Partial<T> & Pick<T, K>

/**
 * Enum of errors that can be thrown (or promises rejected with) when attempting to load a sale.
 *
 * @note if not a good location for this, move it to a more appropriate location.
 * However, it has to not be part of any angular module, as it will make testing harder.
 */
export enum ERROR_TYPES {
  // Error representing a sale not able to be found (e.g. when trying to load that sale).
  LOAD_SALE_ABORTED_NOT_FOUND = 'LOAD_SALE_ABORTED.NOT_FOUND',
  // Error representing aborting the loading of a sale due to the loaded sale being in a Voided state.
  LOAD_SALE_ABORTED_VOIDED = 'LOAD_SALE_ABORTED.VOIDED',
  // Error representing aborting the loading of a sale due to the loaded sale being in a completed state.
  LOAD_SALE_ABORTED_COMPLETED = 'LOAD_SALE_ABORTED.COMPLETED',
  // Error representing a quote not able to be found (e.g. when trying to load that quote).
  LOAD_QUOTE_ABORTED_NOT_FOUND = 'LOAD_QUOTE_ABORTED.NOT_FOUND',
  // Error representing a quote that was already archived.
  LOAD_QUOTE_ABORTED_ARCHIVED = 'LOAD_QUOTE_ABORTED.ARCHIVED',
  // Error representing a quote without a customer.
  LOAD_QUOTE_ABORTED_NO_CUSTOMER = 'LOAD_QUOTE_ABORTED.NO_CUSTOMER',
  // Error representing a quote with no products.
  LOAD_QUOTE_ABORTED_NO_PRODUCTS = 'LOAD_QUOTE_ABORTED.NO_PRODUCTS',
  // Error representing a service agenda not able to be found (e.g. when trying to load that service agenda).
  LOAD_SERVICE_ABORTED_AGENDA_NOT_FOUND = 'LOAD_SERVICE_ABORTED.AGENDA_NOT_FOUND',
  // Error type representing a service item not able to be found (e.g. when trying to load that service item).
  LOAD_SERVICE_ABORTED_SERVICE_ITEM_NOT_FOUND = 'LOAD_SERVICE_ABORTED.SERVICE_ITEM_NOT_FOUND',
  // Error type representing incomplete service
  LOAD_SERVICE_ABORTED_INCOMPLETE = 'LOAD_SERVICE_ABORTED.INCOMPLETE',
}

export enum SERVICE_REFUND_ACTIONS {
  REFUND = 'continue-refund',
  DISMISS = 'dismiss-sale',
}
